import { PUBLIC_NODE_ENV } from '$env/static/public'

export const inDevelopment = () => {
  return PUBLIC_NODE_ENV === 'development'
}

export const inStaging = () => {
  return PUBLIC_NODE_ENV === 'staging'
}

export const inProduction = () => {
  return PUBLIC_NODE_ENV === 'production'
}

export const inTest = () => {
  return PUBLIC_NODE_ENV === 'test'
}
